import sdl from '@jds/react-generated-sdl/JDSSlider';
import type { JDSSliderProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SliderProps } from '../logic';

const Component = (props: SliderProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    editableTextBox = false,
    state = 'undefined',
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaValuenow = props.value?.toString(),
    _ariaValuemin = props.min?.toString(),
    _ariaValuemax = props.max?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      editableTextBox,
      state,
      disabled,
      ariaLabel,
      _ariaValuenow,
      _ariaValuemin,
      _ariaValuemax,
      ...rest
    },
    'JDSSlider',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputSlider = withLogic(Component) as React.FC<SliderProps> & {
  slotName?: string;
};

InputSlider.displayName = 'InputSlider';
InputSlider.slotName = 'jds_slider';

export { InputSlider, type JDSSliderProps };
